import React from 'react';
// import posed, { PoseGroup } from 'react-pose';
import { Route, BrowserRouter } from 'react-router-dom';
import LogRocket from 'logrocket';

import { ThemeProvider } from 'styled-components';
import Routes from './Routes';
import GlobalStyles from './GlobalStyles';


// const RouteContainer = posed.div({
//   enter: { opacity: 1, delay: 100, beforeChildren: true },
//   exit: { opacity: 0 },
// });

// const StyledRouteContainer = styled(RouteContainer)`
//   position: relative;
//   height: 100%;
// `;

LogRocket.init('squrbo/projectx-ah0up');

const theme = {
  primaryColor: '#186bff',
  primaryTextColor: '#333',
  secondaryTextColor: '#888',
  font: {
    small: 14,
  },
};

const App = props => (
  <React.Fragment>
    <GlobalStyles />
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Route render={({ location }) => <Routes location={location} />} />
      </ThemeProvider>
    </BrowserRouter>
  </React.Fragment>
);

export default App;
